<template>
  <div class="report-fs">
      <!-- <div style="margin-top: 178px;" v-if="pathLogo == m"></div>
      <div style="margin-top: 35px;" v-if="pathLogo != m"></div>
      <div class="mlogo t-alignlogo">
        <img class="wlogo" :src="pathLogo" />
      </div> -->
      <h3 class="text-center fs-head-co">{{ allData.fullName }}</h3>
      <h3 class="text-center fs-head-co">{{ allData.shortName }}</h3>
      <h3 class="text-center fs-head"> تقرير البيانات الشخصية </h3>
      <!-- <h3 class="text-center fs-head"> {{ DepartmentId == "" ? "" : data[0].departmentName }}</h3> -->
      <h4 class="text-left" style="margin-left: 50px; direction: ltr">
          التاريخ : {{ convertToUi(new Date()) }}
      </h4>

      <md-card-content dir="rtl" class="redirect-dir">
          <div class="md-layout">
              <div class="md-layout-item">
                  <md-card style="box-shadow: none; ">


                      <div style="margin-top: 10px; margin-bottom: 35px; " class="marginTop">
                          <md-card-content>


                              <md-table class="paginated-table table-striped table-hover mt-25">
                                  <md-table-row>


                                      <md-table-cell >ر.م</md-table-cell>

                                      <md-table-cell class ="w-400" >الاسم</md-table-cell>

                                      <md-table-cell class ="w-200" >الرقم الوطني</md-table-cell>


                                      <md-table-cell class ="w-200" >الجنس</md-table-cell>

                                      <md-table-cell class ="w-200" >العنوان</md-table-cell>

                                      <md-table-cell class ="w-200" >رقم الهاتف</md-table-cell>

                                      <md-table-cell class ="w-200" >تاريخ الميلاد</md-table-cell>
                                      <md-table-cell class ="w-200" >مكان الميلاد</md-table-cell>
                                      <md-table-cell class ="w-200" > اسم الام </md-table-cell>
                                      <md-table-cell class ="w-200" >الحالة الاجتماعية</md-table-cell>
                                      <md-table-cell class ="w-200" >اسم الزوجة </md-table-cell>
                                      <md-table-cell class ="w-200" > جنسية الزوجة </md-table-cell>
                                      <md-table-cell class ="w-200" > عدد الاطفال</md-table-cell>
                                      <md-table-cell class ="w-200" >  البريد الالكتروني</md-table-cell>
                                      <md-table-cell class ="w-200" > السجل المدني المسؤول  </md-table-cell>
                                      <md-table-cell class ="w-200" >رقم القيد</md-table-cell>
                                      <md-table-cell class ="w-200" >رقم ورقة العائلة </md-table-cell>
                                      <md-table-cell class ="w-200" >تاريخ الاصدار كتيب العائلة </md-table-cell>

                                      <md-table-cell class ="w-200" >مكان الاصدار </md-table-cell>

                                      <md-table-cell class ="w-200"  >رقم كتيب العائلة</md-table-cell>

                                      <md-table-cell class ="w-200" >  رقم البطاقة الشخصية</md-table-cell>

                                      <md-table-cell class ="w-200" > تاريخ اصدارها </md-table-cell>

                                      <md-table-cell class ="w-200" >مكان الاصدار</md-table-cell>

                                      <md-table-cell class ="w-200" >الرقم الالي لجواز السفر</md-table-cell>

                                      <md-table-cell class ="w-200" >تاريخ اصدار جواز السفر</md-table-cell>

                                      <md-table-cell class ="w-200" >مكان اصدار جواز السفر</md-table-cell>

                                      <md-table-cell class ="w-200" >رقم جواز السفر</md-table-cell>

                                  </md-table-row>
                                  <md-table-row v-for="(item, i) in data" :key="i">

                                      <md-table-cell  md-label="الصنف">{{
                                          i + 1
                                      }}</md-table-cell>

                                      <md-table-cell class ="w-400"  md-label="الصنف">{{
                                          item.fullName
                                      }}</md-table-cell>


                                      <md-table-cell  md-label="الصنف">{{
                                          item.nationalNumber
                                      }}</md-table-cell>

                                      <md-table-cell  md-label="الصنف">{{
                                          item.genderString
                                      }}</md-table-cell>

                                      <md-table-cell  md-label="الصنف">{{
                                          item.address
                                      }} </md-table-cell>

                                      <md-table-cell  md-label="الصنف">{{
                                          item.phone
                                      }} </md-table-cell>



                                      <md-table-cell  md-label="الصنف">{{
                                         convert( item.birthDate )
                                      }}</md-table-cell>


                                      <md-table-cell  md-label="الصنف">{{
                                          item.birthPlace
                                      }}</md-table-cell>

                                      <md-table-cell  md-label="الصنف">{{
                                         item.motherName
                                      }}</md-table-cell>

                                      <md-table-cell  md-label="الصنف">{{
                                          item.socialStatusString
                                      }}</md-table-cell>


                                      <md-table-cell  md-label="الصنف">{{
                                          item.nameMarried
                                      }}</md-table-cell>


                                      <md-table-cell  md-label="الصنف">{{
                                          item.nationalityName
                                      }}</md-table-cell>

                                      <md-table-cell  md-label="الصنف">{{
                                          item.childerCount
                                      }}</md-table-cell>


                                      <md-table-cell  md-label="الصنف">{{
                                          item.email
                                      }}</md-table-cell>

                                      <md-table-cell  md-label="الصنف">{{
                                         item.bookletCivilRegister
                                      }}</md-table-cell>


                                      <md-table-cell  md-label="الصنف">{{
                                          item.bookletRegistrationFamilyNumber
                                      }}</md-table-cell>

                                      <md-table-cell  md-label="الصنف">{{
                                         item.bookletFamilyNumber
                                      }}</md-table-cell>

                                      <md-table-cell  md-label="الصنف">{{
                                           convert( item.bookletIssueDate)
                                      }}</md-table-cell>

                                      <md-table-cell  md-label="الصنف">{{
                                          item.bookletIssuePlace
                                      }}</md-table-cell>

                                      <md-table-cell  md-label="الصنف">{{
                                          item.bookletNumber
                                      }}</md-table-cell>

                                      <md-table-cell  md-label="الصنف">{{
                                          item.identificationCardNumber
                                      }}</md-table-cell>

                                      <md-table-cell  md-label="الصنف">{{
                                           convert( item.identificationCardIssueDate)
                                      }}</md-table-cell>


                                      <md-table-cell  md-label="الصنف">{{
                                         item.identificationCardIssuePlace
                                      }}</md-table-cell>

                                      <md-table-cell  md-label="الصنف">{{
                                          item.passportAutoNumber
                                      }}</md-table-cell>

                                      <md-table-cell  md-label="الصنف">{{
                                           convert( item.passportIssueDate)
                                      }}</md-table-cell>

                                      <md-table-cell  md-label="الصنف">{{
                                          item.passportIssuePlace
                                      }}</md-table-cell>

                                      <md-table-cell  md-label="الصنف">{{
                                          item.passportNumber
                                      }}</md-table-cell>

                                     
                                  </md-table-row>
                              </md-table>

                          </md-card-content>
                      </div>

                  </md-card>
              </div>

          </div>
      </md-card-content>

  </div>
</template>

<script>
//  import { count } from "console";
import env from "../../../env";

export default {
  mounted() { },
  props: ["data", "pathLogo", "allData", "vacationYear"],
  data() {
      return {
          currentSort: "",
          currentSortOrder: "asc",
          m: env.mTop(),

      };
  },
  methods: {
      convert(event) {
          try {
              let d = new Date(event);
              if (event == null) {
                    return "";
                }
              return (
                  d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

                  // +
                  // " , "
                  // +
                  // d.getHours() +
                  // ":" +
                  // d.getMinutes()
              );
          } catch (error) { }
      },
      convertToUi(event) {
          try {
              let d = new Date(event);
              if (isNaN(d.getFullYear()) === true) {
                  return " - ";
              }
              return (
                  d.getDate() + " - " + (d.getMonth() + 1) + " - " + d.getFullYear()

                  // +
                  // " , "
                  // +
                  // d.getHours() +
                  // ":" +
                  // d.getMinutes()
              );
          } catch (error) { }
      },
      customSort(value) {
          return value.sort((a, b) => {
              const sortBy = this.currentSort;
              if (this.currentSortOrder === "desc") {
                  return a[sortBy].localeCompare(b[sortBy]);
              }
              return b[sortBy].localeCompare(a[sortBy]);
          });
      },
  },
};
</script>

<style lang="scss" scoped>

.report-fs {
  * {
      font-size: 22px !important;
      font-family: "Cairo", sans-serif !important;
  }

  .md-table-head {
      .md-table-head-container {
          .md-table-head-label {
              font-size: 22px !important;
          }
      }
  }

  .fs-head-co {
      font-size: 29px !important;
      font-weight: bold;
  }

  .fs-head {
      font-size: 25px !important;
  }

  .custom-mt {
      margin-bottom: 440px;
  }

  .border-staffLists {
      border: 1px solid #000;
      /* border-left: none; */
      border-top: 1px solid #000 !important;
      height: 90px;
  }


}
</style>